import { getDefaultAxios } from "./DefaultAxios";

export default class PlayerRequests { 
    defaultAxios : any;
    constructor(){
        this.defaultAxios = getDefaultAxios("Players");
    }
    
    GetAll(serverId: any, onSuccess : any){
        this.defaultAxios.get(`/GetAll/${serverId}`)
        .then((res: any) => 
            onSuccess(res.data)
        );
    }

    GetPlayerIP(serverId: any, userGameId : any, onSuccess : any){
        this.defaultAxios.get(`/GetPlayerIP/${serverId}/${userGameId}`).then((res: any) => 
            onSuccess(res.data)
        );
    }

    BanOfflinePlayers(serverId: any, time : any, PlayersToBanList: any, Reason: any, onSuccess : any){
        const data = {
            serverId : serverId,
            time : time,
            PlayersToBanList : PlayersToBanList,
            Reason : Reason
        }
        
        return this.defaultAxios.post(`BanOfflinePlayers`, data).then((res: any) => 
            onSuccess(res.data)
        );
    }
}